"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = require("vue");
var vue_2 = require("vue");
var _hoisted_1 = { class: "position-relative" };
var _hoisted_2 = /*#__PURE__*/ (0, vue_2.createElementVNode)("div", { class: "client-preview" }, [
    /*#__PURE__*/ (0, vue_2.createElementVNode)("label", { for: "" }, "Chosir le client"),
    /*#__PURE__*/ (0, vue_2.createElementVNode)("select", {
        name: "client_id",
        id: "client_id",
        placeholder: "Raison social, Prénoms, ..."
    })
], -1);
var _hoisted_3 = [
    _hoisted_2
];
var tom_select_1 = __importDefault(require("tom-select"));
var vue_3 = require("vue");
var models_1 = require("../models");
exports.default = (0, vue_1.defineComponent)({
    name: 'ClientSelector',
    props: {
        client: {
            type: models_1.Client,
            required: false
        },
        preload: {
            type: Boolean,
            default: false
        }
    },
    emits: ['selected'],
    setup: function (__props, _a) {
        var emit = _a.emit;
        var props = __props;
        (0, vue_3.onMounted)(function () {
            new tom_select_1.default('#client_id', {
                create: false,
                items: props.client ? [props.client.id.toString()] : [],
                options: props.client ? [props.client] : [],
                maxItems: 1,
                closeAfterSelect: true,
                valueField: 'id',
                labelField: 'summer',
                searchField: ['title', 'firstname', 'lastname'],
                preload: props.preload,
                load: function (q, callback) {
                    globalThis.axios.get('/api/clients', { params: { q: q } })
                        .then(function (resp) {
                        var data = resp.data.map(function (item) { return new models_1.Client(item); });
                        callback(data, []);
                    })
                        .catch(function () {
                        callback([], []);
                    });
                },
                onItemAdd: function (value) {
                    emit('selected', value);
                }
            });
        });
        return function (_ctx, _cache) {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_1, _hoisted_3));
        };
    }
});
